import React from 'react'

import 'react-app-polyfill/stable'
import ReactDOM from 'react-dom'

import App from './App'

ReactDOM.render(<App />, document.getElementById('root'))
